export default __webpack_public_path__ + "static/media/Connecticut2.8ac315d2.png";